import { useParams, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth';

export function useScope() {
  const params = useParams();
  const { pathname } = useLocation();
  const { tenantSlug: authTenantSlug } = useAuth();

  const tenantSlug = authTenantSlug || 'ptf';

  let organizationSlug = params.slug as string | undefined;

  if (!organizationSlug) {
    // Extract from pathname: /org/{slug}/... or /settings/org/{slug}/...
    const match = pathname.match(/^\/(?:settings\/)?org\/([^/]+)/);
    if (match) {
      organizationSlug = match[1];
    }
  }

  return { tenantSlug, organizationSlug };
}

export function useScopedHeaders() {
  const { tenantSlug, organizationSlug } = useScope();
  const headers: Record<string, string> = {};

  headers['x-tenant-slug'] = tenantSlug;

  if (organizationSlug) {
    headers['x-organization-slug'] = organizationSlug as string;
  }

  return headers;
}
